export enum TaffiSubjects {
    TAFFI_SIZE = 'TAFFI_SIZE',
    TAFFI_GENDER = 'TAFFI_GENDER',
    TAFFI_PURPOSE = 'TAFFI_PURPOSE',
    TAFFI_SEASON = 'TAFFI_SEASON',
    TAFFI_AGE = 'TAFFI_AGE',
    TAFFI_PERSONAL = 'TAFFI_PERSONAL',
    TAFFI_BODY_SHAPES = 'TAFFI_BODY_SHAPES',
    TAFFI_BODY_TYPES = 'TAFFI_BODY_TYPES',
    TAFFI_COLOR = 'TAFFI_COLOR',
    ITEM_STYLE_ACCESS = 'ITEM_STYLE_ACCESS',
    TAFFI_SKINTONE = 'TAFFI_SKINTONE',
    TAFFI_SKIN_UNDERTONE = 'TAFFI_SKIN_UNDERTONE',
    TAFFI_HAIR_COLOR = 'TAFFI_HAIR_COLOR',
    TAFFI_BIRTHDAY = 'TAFFI_BIRTHDAY',
}
